import gql from 'graphql-tag';

export default gql`
  mutation enableUser($userId: UUID!) {
    enableUser(userId: $userId)
  }
`;
